var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"background--color",class:_vm.fontType,attrs:{"id":"app"}},[(!_vm.$route.meta.hideHeader)?_c('div',[_c('Navbar')],1):_vm._e(),_c('div',{style:(_vm.mobileMargin)},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }